module.exports = __webpack_public_path__ + "06_long_black.eb9379a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/06_long_black.png
// module id = YMFk
// module chunks = 0